import React from 'react';
import SignatureModal from "../SignatureModal.jsx";
import AriaLiveRegion from '../AriaLiveRegion';

function SignatureInput({ index, inputField, setHoveredIndex, setSignatureOpen, updateSignature, handleMouseEnter, handleMouseLeave, hoveredIndex, windowWidth, pageHeight, pageWidth }) {
  const hasError = !inputField.valid;
  const errorId = hasError ? `error-${inputField.editor.inputType.value}-${index}` : undefined;
  const fieldLabel = inputField.editor.inputType.label || inputField.editor.inputType.value;

  // Error message for screen readers
  const errorMessage = hasError ? `שדה חתימה ${fieldLabel} דורש חתימה` : '';

  // CRITICAL FIX: Calculate rendered PDF height correctly
  const renderedHeight = windowWidth * (pageHeight / pageWidth);
  const fieldHeight = windowWidth * inputField.editor.height / 40;

  return (
    <>
      <div key={index}
        style={{
          opacity: `${hoveredIndex === index || inputField.editor.state ? 0.8 : 1}`,
          position: 'absolute',
          top: inputField.y * renderedHeight,
          left: inputField.x * windowWidth,
          fontSize: `${windowWidth / 40}px`,
          width: `${(windowWidth * inputField.editor.width / 1.5)}px`,
          padding: '4px',
          border: `${inputField.valid? '':'2px solid red'}`
        }}
        role="button"
        aria-label={`${fieldLabel} - לחץ לחתימה`}
        aria-invalid={hasError}
        aria-describedby={errorId}
        aria-required={inputField.mandatory ? 'true' : 'false'}
        tabIndex={0}
        onMouseEnter={(event) => handleMouseEnter(event, index)}
        onMouseLeave={handleMouseLeave}
      >
        <SignatureModal key={index} windowWidth={windowWidth} setHoveredIndex={setHoveredIndex} setSignatureOpen={setSignatureOpen} updateSignature={updateSignature} url={inputField.value} index={index} signer={"חתימה ראשונה"} />
      </div>
      {hasError && (
        <AriaLiveRegion
          id={errorId}
          message={errorMessage}
          type="error"
          visible={false}
          sx={{
            position: 'absolute',
            top: inputField.y * renderedHeight + fieldHeight + 2,
            left: inputField.x * windowWidth,
            fontSize: `${windowWidth / 80}px`,
            color: '#ef4444',
            pointerEvents: 'none',
          }}
        />
      )}
    </>
  );
}

export default SignatureInput;
